var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { yupResolver } from '@hookform/resolvers/yup';
import { LoadingButton } from '@mui/lab';
import { Box, Button, DialogActions, DialogContent, DialogTitle, Divider, FormControlLabel, Grid, Radio, TextField, Typography, styled } from '@mui/material';
import { DatePicker } from '@mui/x-date-pickers';
import { useEffect, useMemo, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { StyledDialog } from '.';
import { Language, MFAType, OrgType, Role, StatusPermission, UserType, getLicenseType } from '../../enum';
import { useUserSessionAPI } from '../app/selectors';
import { Autocomplete, ErrorMessageBox, FallbackComponent, FormField, InputLabel, MultiAutocomplete, PhoneInput, RadioGroup, UnControlledFormField } from '../common';
import { Tooltip } from '../common/tooltip';
import { useCompaniesAPI, useCompanyById, useCompanyNames, useCreateUserAPI, useDefaultOrg, useIsSuperAdmin, useOrgLobsAPI, useOrgMultiGeoClientsAPI, useOrgStatusAPI, useSaveUserAccessAPI, useUpdateUserAPI, useUserAPI, useUserAccessAPI } from './selectors';
import { PermissionName } from './types';
import { useUserAccessState } from './useUserAccessState';
var PermissionGrid = styled(Grid)({
  paddingTop: '0.5rem !important'
});
var OrgPermCard = styled(Box)(function (_a) {
  var theme = _a.theme;
  return {
    border: "1px solid ".concat(theme.palette.divider),
    borderRadius: theme.shape.borderRadius,
    overflow: 'auto',
    maxHeight: 300,
    marginTop: '0.5rem'
  };
});
var OrgPermRow = styled(Box)(function (_a) {
  var theme = _a.theme,
    _b = _a.indent,
    indent = _b === void 0 ? 0 : _b;
  return {
    display: 'flex',
    alignItems: 'center',
    padding: "0.25rem 0.75rem",
    paddingLeft: "".concat(0.75 + indent * 2, "rem"),
    borderBottom: "1px solid ".concat(theme.palette.divider),
    '&:last-child': {
      borderBottom: 'none'
    },
    backgroundColor: indent === 0 ? theme.palette.action.hover : 'transparent'
  };
});
var PermissionSection = function (props) {
  var t = useTranslation(['manageUser']).t;
  return _jsxs(_Fragment, {
    children: [props.hidePermission && _jsx(PermissionGrid, __assign({
      item: true,
      xs: 12
    }, {
      children: _jsx(Divider, {})
    })), _jsxs(PermissionGrid, __assign({
      item: true,
      xs: 12,
      display: "flex"
    }, {
      children: [_jsx(Grid, __assign({
        item: true,
        xs: 6
      }, {
        children: _jsx(Typography, __assign({
          paddingTop: 2
        }, {
          children: props.label
        }))
      })), _jsx(Grid, __assign({
        item: true,
        xs: 6,
        pl: 2
      }, {
        children: _jsx(FormField, __assign({
          name: props.name,
          control: props.control
        }, {
          children: _jsxs(RadioGroup, __assign({
            row: true
          }, {
            children: [_jsx(FormControlLabel, __assign({
              control: _jsx(Radio, {}),
              label: t('edit'),
              disabled: props.disabled || Number(props.userType) === UserType.Viewer
            }, !props.disabled && {
              value: StatusPermission.Edit
            })), _jsx(FormControlLabel, __assign({
              control: _jsx(Radio, {}),
              label: t('view'),
              disabled: props.disabled
            }, !props.disabled && {
              value: StatusPermission.View
            })), props.hidePermission && _jsx(FormControlLabel, __assign({
              control: _jsx(Radio, {}),
              label: t('hide'),
              disabled: props.disabled
            }, !props.disabled && {
              value: StatusPermission.Hide
            }))]
          }))
        }))
      }))]
    }))]
  });
};
var HierarchyPermRow = function (_a) {
  var label = _a.label,
    _b = _a.indent,
    indent = _b === void 0 ? 0 : _b,
    permission = _a.permission,
    onChange = _a.onChange,
    disabled = _a.disabled,
    userType = _a.userType,
    _c = _a.hideOption,
    hideOption = _c === void 0 ? false : _c;
  var t = useTranslation(['manageUser']).t;
  return _jsxs(OrgPermRow, __assign({
    indent: indent
  }, {
    children: [_jsx(Box, __assign({
      flex: 1
    }, {
      children: _jsx(Typography, __assign({
        variant: "body2"
      }, {
        children: label
      }))
    })), _jsx(Box, {
      children: _jsxs(RadioGroup, __assign({
        row: true,
        value: permission,
        onChange: function (_, val) {
          return onChange(val);
        }
      }, {
        children: [_jsx(FormControlLabel, {
          control: _jsx(Radio, {
            size: "small"
          }),
          label: t('edit'),
          value: StatusPermission.Edit,
          disabled: disabled || Number(userType) === UserType.Viewer
        }), _jsx(FormControlLabel, {
          control: _jsx(Radio, {
            size: "small"
          }),
          label: t('view'),
          value: StatusPermission.View,
          disabled: disabled
        }), hideOption && _jsx(FormControlLabel, {
          control: _jsx(Radio, {
            size: "small"
          }),
          label: t('hide'),
          value: StatusPermission.Hide,
          disabled: disabled
        })]
      }))
    })]
  }));
};
export var UserDialog = function (_a) {
  var _b, _c, _d, _e, _f;
  var open = _a.open,
    user = _a.user,
    onClose = _a.onClose,
    onUserSaved = _a.onUserSaved;
  var t = useTranslation(['manageUser', 'translation']).t;
  var userId = user === null || user === void 0 ? void 0 : user.id;
  var orgType = (_b = user === null || user === void 0 ? void 0 : user.orgs[0].orgType) !== null && _b !== void 0 ? _b : OrgType.Cinareo;
  var _g = useUserAPI(userId),
    userData = _g[0],
    fetchUserData = _g[1],
    clearUserData = _g[2];
  var _h = useCompaniesAPI(orgType),
    companiesData = _h[0],
    fetchCompanies = _h[1],
    clearCompanies = _h[2];
  var _j = useCreateUserAPI(),
    createData = _j[0],
    createUser = _j[1],
    clearCreateData = _j[2];
  var _k = useUpdateUserAPI(userId),
    updateData = _k[0],
    updateUser = _k[1],
    clearUpdateData = _k[2];
  var _l = useUserSessionAPI(),
    userSessionData = _l[0],
    fetchUserSessionData = _l[1];
  var companyNames = useCompanyNames(orgType);
  var isCurrentUser = userId === ((_c = userSessionData.data) === null || _c === void 0 ? void 0 : _c.id);
  var isSuperAdmin = useIsSuperAdmin();
  var defaultOrg = useDefaultOrg();
  // Multi-Geo API hooks
  var _m = useOrgMultiGeoClientsAPI(),
    clientsData = _m[0],
    fetchClientsMultiGeo = _m[1],
    clearClientsMultiGeo = _m[2];
  var _o = useOrgLobsAPI(),
    lobsData = _o[0],
    fetchLobs = _o[1],
    clearLobs = _o[2];
  var _p = useUserAccessAPI(userId),
    accessData = _p[0],
    fetchAccess = _p[1],
    clearAccess = _p[2];
  var _q = useSaveUserAccessAPI(),
    saveAccessData = _q[0],
    saveAccess = _q[1],
    clearSaveAccess = _q[2];
  // Wizard step
  var _r = useState(0),
    activeStep = _r[0],
    setActiveStep = _r[1];
  var defaultValues = useMemo(function () {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y;
    return {
      orgId: (_b = (_a = userData.data) === null || _a === void 0 ? void 0 : _a.orgs[0].id) !== null && _b !== void 0 ? _b : defaultOrg === null || defaultOrg === void 0 ? void 0 : defaultOrg.id,
      name: (_d = (_c = userData.data) === null || _c === void 0 ? void 0 : _c.name) !== null && _d !== void 0 ? _d : '',
      email: (_f = (_e = userData.data) === null || _e === void 0 ? void 0 : _e.email) !== null && _f !== void 0 ? _f : '',
      phone: (_h = (_g = userData.data) === null || _g === void 0 ? void 0 : _g.phone) !== null && _h !== void 0 ? _h : '',
      language: (_k = (_j = userData.data) === null || _j === void 0 ? void 0 : _j.language) !== null && _k !== void 0 ? _k : Language.EN,
      PreferredMfaSetting: (_l = userData.data) === null || _l === void 0 ? void 0 : _l.PreferredMfaSetting,
      versionId: (_o = (_m = userData.data) === null || _m === void 0 ? void 0 : _m.versionId) !== null && _o !== void 0 ? _o : Role.User,
      userType: (_q = (_p = userData.data) === null || _p === void 0 ? void 0 : _p.userOrgs[0].userType) !== null && _q !== void 0 ? _q : UserType.Planner,
      capacityPermission: (_s = (_r = userData.data) === null || _r === void 0 ? void 0 : _r.userOrgs[0].capacityPermission) !== null && _s !== void 0 ? _s : StatusPermission.Edit,
      financialPermission: (_u = (_t = userData.data) === null || _t === void 0 ? void 0 : _t.userOrgs[0].financialPermission) !== null && _u !== void 0 ? _u : StatusPermission.Edit,
      recruitmentPermission: (_w = (_v = userData.data) === null || _v === void 0 ? void 0 : _v.userOrgs[0].recruitmentPermission) !== null && _w !== void 0 ? _w : StatusPermission.Edit,
      actualPermission: (_y = (_x = userData.data) === null || _x === void 0 ? void 0 : _x.userOrgs[0].actualPermission) !== null && _y !== void 0 ? _y : StatusPermission.Edit
    };
  }, [userData.data, defaultOrg === null || defaultOrg === void 0 ? void 0 : defaultOrg.id]);
  var validateForm = yup.object().shape({
    orgId: yup.number().nullable().required(),
    name: yup.string().required().max(50).normalizeSpace().label('Name'),
    email: yup.string().email().required().max(50).trim().label('Email'),
    phone: yup.string().max(20).phone().trim().label('Phone'),
    PreferredMfaSetting: yup.string().nullable(),
    recruitmentPermission: yup.string().nullable(),
    financialPermission: yup.string().nullable(),
    capacityPermission: yup.string().nullable(),
    actualPermission: yup.string().nullable(),
    versionId: yup.number().required(),
    userType: yup.number().required()
  });
  var _s = useForm({
      defaultValues: defaultValues,
      resolver: yupResolver(validateForm)
    }),
    control = _s.control,
    errors = _s.formState.errors,
    handleSubmit = _s.handleSubmit,
    reset = _s.reset,
    watch = _s.watch,
    setValue = _s.setValue,
    getValues = _s.getValues,
    trigger = _s.trigger;
  var _t = watch(),
    phone = _t.phone,
    email = _t.email,
    orgId = _t.orgId,
    versionId = _t.versionId,
    userType = _t.userType;
  var isAdminLicense = Number(versionId) === Role.Admin || Number(versionId) === Role.Superadmin;
  var company = useCompanyById(orgType, orgId);
  var _u = useOrgStatusAPI(orgId),
    orgStatus = _u[0],
    fetchOrgStatus = _u[1];
  var isSsoCompany = !!(userId ? (_e = (_d = userData.data) === null || _d === void 0 ? void 0 : _d.orgs[0]) === null || _e === void 0 ? void 0 : _e.ssoEnabled : company === null || company === void 0 ? void 0 : company.ssoEnabled);
  var selectedOrg = isSuperAdmin ? (_f = companiesData.data) === null || _f === void 0 ? void 0 : _f.find(function (c) {
    return c.id === orgId;
  }) : defaultOrg;
  var isBpo = !!(selectedOrg === null || selectedOrg === void 0 ? void 0 : selectedOrg.isBpo);
  var clients = useMemo(function () {
    var _a;
    return (_a = clientsData.data) !== null && _a !== void 0 ? _a : [];
  }, [clientsData.data]);
  var clientOptions = useMemo(function () {
    return clients.map(function (c) {
      return {
        id: c.id,
        name: c.clientName
      };
    });
  }, [clients]);
  var allLobs = useMemo(function () {
    var _a;
    return (_a = lobsData.data) !== null && _a !== void 0 ? _a : [];
  }, [lobsData.data]);
  var plannerAvailable = useMemo(function () {
    var _a, _b, _c, _d;
    var isUserSuperAdmin = ((_a = userData.data) === null || _a === void 0 ? void 0 : _a.versionId) === Role.Superadmin;
    if (isUserSuperAdmin) return true;
    var isCurrentOrg = ((_c = (_b = userData.data) === null || _b === void 0 ? void 0 : _b.orgs[0]) === null || _c === void 0 ? void 0 : _c.id) === (company === null || company === void 0 ? void 0 : company.id);
    var isCurrentPlanner = ((_d = userData.data) === null || _d === void 0 ? void 0 : _d.userOrgs[0].userType) === UserType.Planner;
    var orgStatusData = orgStatus === null || orgStatus === void 0 ? void 0 : orgStatus.data;
    if (isCurrentOrg && isCurrentPlanner || !orgStatusData || (orgStatusData === null || orgStatusData === void 0 ? void 0 : orgStatusData.licensesUnlimited)) return true;
    return orgStatusData.numberOfLicenses > orgStatusData.usedLicenses;
  }, [userData.data, company === null || company === void 0 ? void 0 : company.id, orgStatus === null || orgStatus === void 0 ? void 0 : orgStatus.data]);
  // User org data for access hook pre-fill
  var userOrgData = useMemo(function () {
    var _a;
    if (!((_a = userData.data) === null || _a === void 0 ? void 0 : _a.userOrgs[0])) return undefined;
    return {
      orgConfigPermission: userData.data.userOrgs[0].orgConfigPermission
    };
  }, [userData.data]);
  // Access state hook — manages selections, permissions, validation, and cascading
  var access = useUserAccessState({
    open: open,
    userType: userType,
    isBpo: isBpo,
    accessData: accessData.data,
    userOrgData: userOrgData,
    allLobs: allLobs,
    clients: clients,
    t: t
  });
  var selectedClientIds = access.selectedClientIds,
    setSelectedClientIds = access.setSelectedClientIds,
    selectedLobKeys = access.selectedLobKeys,
    step1Errors = access.step1Errors,
    orgConfigPermission = access.orgConfigPermission,
    setOrgConfigPermission = access.setOrgConfigPermission,
    clientPermissions = access.clientPermissions,
    lobPermissions = access.lobPermissions,
    defaultPerm = access.defaultPerm,
    allPermsHidden = access.allPermsHidden,
    validateStep1 = access.validateStep1,
    buildAccessPayload = access.buildAccessPayload,
    initializeStep2Permissions = access.initializeStep2Permissions,
    handleCascadeClientPerm = access.handleCascadeClientPerm,
    handleCascadeLobPerm = access.handleCascadeLobPerm,
    resetAccessState = access.resetAccessState,
    clearSelectionsForOrgChange = access.clearSelectionsForOrgChange;
  useEffect(function () {
    open && orgId && fetchOrgStatus();
    if (!open) {
      setValue('orgId', null);
    }
  }, [orgId, fetchOrgStatus, open, setValue]);
  useEffect(function () {
    if (open) {
      userId && fetchUserData();
      userId && fetchAccess();
      isSuperAdmin && fetchCompanies();
      if (!isSuperAdmin) {
        fetchLobs();
      }
      return function () {
        clearUserData();
        clearCompanies();
        clearCreateData();
        clearUpdateData();
        clearAccess();
        clearClientsMultiGeo();
        clearLobs();
        clearSaveAccess();
        setActiveStep(0);
        resetAccessState();
      };
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- fetch/clear fns from useAPI have unstable refs; re-running on every render would cause infinite loops
  }, [open, userId]);
  useEffect(function () {
    if (open && isSuperAdmin && orgId) {
      if (!userId) {
        clearClientsMultiGeo();
        clearLobs();
        clearSelectionsForOrgChange();
      }
      fetchLobs(undefined, {
        orgId: orgId
      });
      if (isBpo) {
        fetchClientsMultiGeo(undefined, {
          orgId: orgId
        });
      } else {
        clearClientsMultiGeo();
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- same reason: useAPI returns new fn refs every render
  }, [open, orgId]);
  // Fetch BPO clients for non-superadmin
  useEffect(function () {
    if (open && !isSuperAdmin) {
      if (isBpo) {
        fetchClientsMultiGeo();
      } else {
        clearClientsMultiGeo();
        setSelectedClientIds([]);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- same reason: useAPI returns new fn refs every render
  }, [open, isBpo]);
  useEffect(function () {
    reset(defaultValues);
  }, [defaultValues, open, reset]);
  // Auto-set orgConfigPermission based on license type
  useEffect(function () {
    if (!userId) {
      setOrgConfigPermission(isAdminLicense ? StatusPermission.Edit : StatusPermission.View);
    } else if (isAdminLicense) {
      // Upgrade from Hide to Edit when license is set to Admin for existing users
      setOrgConfigPermission(function (prev) {
        return prev === StatusPermission.Hide ? StatusPermission.Edit : prev;
      });
    } else {
      // Cap to View when license is downgraded from Admin to User for existing users
      setOrgConfigPermission(function (prev) {
        return prev === StatusPermission.Edit ? StatusPermission.View : prev;
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps -- setOrgConfigPermission is a stable setState setter but ESLint can't infer that from the hook return type
  }, [versionId, userId]);
  useEffect(function () {
    var _a, _b;
    if (createData.data || updateData.data) {
      var newUserId = (_b = (_a = createData.data) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : userId;
      if (newUserId) {
        var accessPayload = buildAccessPayload();
        saveAccess(accessPayload, {
          id: newUserId
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [createData.data, updateData.data]);
  useEffect(function () {
    if (saveAccessData.data) {
      var created = !!createData.data;
      onClose();
      onUserSaved === null || onUserSaved === void 0 ? void 0 : onUserSaved({
        created: created
      });
      if (!isSuperAdmin && createData.data || updateData.data) fetchUserSessionData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [saveAccessData.data]);
  useEffect(function () {
    if (open && Number(userType) === UserType.Viewer) {
      Object.values(PermissionName).forEach(function (perm) {
        if (getValues(perm) === StatusPermission.Edit) {
          setValue(perm, StatusPermission.View);
        }
      });
    }
  }, [getValues, setValue, userType, open]);
  useEffect(function () {
    if (open && !plannerAvailable) {
      setValue('userType', UserType.Viewer);
    }
  }, [plannerAvailable, setValue, open]);
  var handleChangePhoneNumber = function (phoneNumber) {
    var _a, _b;
    if (!((_b = (_a = userData.data) === null || _a === void 0 ? void 0 : _a.UserMFASettingList) === null || _b === void 0 ? void 0 : _b.includes(MFAType.TOTP))) {
      setValue('PreferredMfaSetting', phoneNumber ? MFAType.SMS : null);
    } else if (getValues('PreferredMfaSetting') === MFAType.SMS && !phoneNumber) {
      setValue('PreferredMfaSetting', MFAType.TOTP);
    }
  };
  var handleNext = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      var formValid;
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            return [4 /*yield*/, trigger(['orgId', 'name', 'email', 'phone', 'versionId', 'userType'])];
          case 1:
            formValid = _a.sent();
            if (!formValid) return [2 /*return*/];
            if (!validateStep1()) return [2 /*return*/];
            initializeStep2Permissions();
            setActiveStep(1);
            return [2 /*return*/];
        }
      });
    });
  };
  var handleFormSubmit = function (values) {
    var _a;
    // If user was already created but access save failed, retry access save only
    var createdUserId = (_a = createData.data) === null || _a === void 0 ? void 0 : _a.id;
    if (!userId && createdUserId) {
      clearSaveAccess();
      saveAccess(buildAccessPayload(), {
        id: createdUserId
      });
      return;
    }
    if (userId) {
      updateUser(__assign(__assign({}, values), {
        orgConfigPermission: orgConfigPermission
      }));
    } else {
      createUser(__assign(__assign({}, values), {
        orgConfigPermission: orgConfigPermission
      }));
    }
  };
  var isLoading = !!userId && !userData.data && !userData.error || !!userData.requesting || !!companiesData.requesting || !!createData.requesting || !!updateData.requesting || !!orgStatus.requesting || !!accessData.requesting;
  var isSaving = !!createData.requesting || !!updateData.requesting || !!saveAccessData.requesting;
  // Render Step 1: User Info + Access selections
  var renderStep1 = function () {
    var _a, _b, _c, _d, _e, _f;
    return _jsxs(Grid, __assign({
      container: true,
      spacing: 4
    }, {
      children: [isSuperAdmin && _jsxs(_Fragment, {
        children: [_jsx(Grid, __assign({
          item: true,
          xs: 6
        }, {
          children: _jsx(UnControlledFormField, __assign({
            required: true,
            label: t('company'),
            errorMessage: (_a = errors.orgId) === null || _a === void 0 ? void 0 : _a.message
          }, {
            children: orgType === OrgType.Cinareo ? _jsx(Autocomplete, {
              "data-testid": "companySelect",
              loading: companiesData.requesting,
              options: companyNames,
              value: company === null || company === void 0 ? void 0 : company.orgs[0].id,
              onChange: function (value) {
                setValue('orgId', value);
                trigger('orgId');
              },
              error: !!errors.orgId
            }) : _jsx(Tooltip, __assign({
              title: user === null || user === void 0 ? void 0 : user.companyName
            }, {
              children: _jsx(Typography, __assign({
                paddingTop: 2
              }, {
                children: user === null || user === void 0 ? void 0 : user.companyName
              }))
            }))
          }))
        })), _jsx(Grid, __assign({
          item: true,
          xs: 6
        }, {
          children: _jsx(FormField, __assign({
            required: true,
            name: "orgId",
            label: t('country'),
            control: control
          }, {
            children: _jsx(Autocomplete, {
              "data-testid": "countrySelect",
              placeholder: t('pleaseSelect'),
              loading: companiesData.requesting,
              options: company === null || company === void 0 ? void 0 : company.countries
            })
          }))
        })), _jsx(Grid, __assign({
          item: true,
          xs: 6
        }, {
          children: _jsx(UnControlledFormField, __assign({
            required: true,
            label: t('subscriptionStartDate')
          }, {
            children: _jsx(DatePicker, {
              disabled: true,
              value: (_b = company === null || company === void 0 ? void 0 : company.subscriptionStartDate) !== null && _b !== void 0 ? _b : null
            })
          }))
        })), _jsx(Grid, __assign({
          item: true,
          xs: 6
        }, {
          children: _jsx(UnControlledFormField, __assign({
            required: true,
            label: t('subscriptionEndDate')
          }, {
            children: _jsx(DatePicker, {
              disabled: true,
              value: (_c = company === null || company === void 0 ? void 0 : company.subscriptionEndDate) !== null && _c !== void 0 ? _c : null
            })
          }))
        }))]
      }), _jsx(Grid, __assign({
        item: true,
        xs: 6
      }, {
        children: _jsx(FormField, __assign({
          required: true,
          name: "name",
          label: t('nameUser'),
          control: control
        }, {
          children: _jsx(TextField, {
            inputProps: {
              maxLength: 50
            }
          })
        }))
      })), _jsx(Grid, __assign({
        item: true,
        xs: 6
      }, {
        children: _jsx(FormField, __assign({
          required: true,
          name: "email",
          label: t('email'),
          control: control
        }, {
          children: _jsx(TextField, {
            type: "email",
            disabled: !!userId,
            inputProps: {
              maxLength: 50
            }
          })
        }))
      })), !isSsoCompany && _jsxs(_Fragment, {
        children: [_jsx(Grid, __assign({
          item: true,
          xs: 6
        }, {
          children: _jsx(FormField, __assign({
            name: "phone",
            label: t('phoneNumber'),
            control: control
          }, {
            children: _jsx(PhoneInput, {
              "data-testid": "phoneInput",
              disabled: ((_d = userSessionData.data) === null || _d === void 0 ? void 0 : _d.email) === email,
              onChange: handleChangePhoneNumber
            })
          }))
        })), _jsx(Grid, __assign({
          item: true,
          xs: 6
        }, {
          children: _jsx(FormField, __assign({
            name: "PreferredMfaSetting",
            label: t('referredMFA'),
            control: control
          }, {
            children: _jsxs(RadioGroup, __assign({
              row: true
            }, {
              children: [_jsx(FormControlLabel, {
                control: _jsx(Radio, {}),
                label: t('sms'),
                disabled: !phone,
                value: MFAType.SMS
              }), _jsx(FormControlLabel, {
                control: _jsx(Radio, {}),
                label: t('totp'),
                disabled: !((_f = (_e = userData.data) === null || _e === void 0 ? void 0 : _e.UserMFASettingList) === null || _f === void 0 ? void 0 : _f.includes(MFAType.TOTP)),
                value: MFAType.TOTP
              })]
            }))
          }))
        }))]
      }), _jsx(Grid, __assign({
        item: true,
        xs: 6
      }, {
        children: _jsx(FormField, __assign({
          name: "versionId",
          label: t('licenseTypeTitle'),
          control: control,
          required: true
        }, {
          children: _jsx(Autocomplete, {
            options: getLicenseType(versionId),
            disabled: versionId === Role.Superadmin || isCurrentUser
          })
        }))
      })), _jsx(Grid, __assign({
        item: true,
        xs: 6
      }, {
        children: _jsx(FormField, __assign({
          name: "language",
          label: t('languageTitle'),
          control: control
        }, {
          children: _jsxs(RadioGroup, __assign({
            row: true
          }, {
            children: [_jsx(FormControlLabel, {
              control: _jsx(Radio, {}),
              label: t('languageOption.english'),
              value: Language.EN
            }), _jsx(FormControlLabel, {
              control: _jsx(Radio, {}),
              label: t('languageOption.french'),
              value: Language.FR
            })]
          }))
        }))
      })), _jsx(Grid, __assign({
        item: true,
        xs: 12
      }, {
        children: _jsx(FormField, __assign({
          name: "userType",
          label: t('userTypeTitle'),
          control: control,
          required: true
        }, {
          children: _jsxs(RadioGroup, __assign({
            row: true
          }, {
            children: [_jsx(FormControlLabel, {
              control: _jsx(Radio, {}),
              label: t('userTypeOption.planner'),
              value: UserType.Planner,
              disabled: !plannerAvailable
            }), _jsx(FormControlLabel, {
              control: _jsx(Radio, {}),
              label: t('userTypeOption.viewer'),
              value: UserType.Viewer
            })]
          }))
        }))
      })), isBpo && _jsx(Grid, __assign({
        item: true,
        xs: 6
      }, {
        children: _jsx(UnControlledFormField, __assign({
          required: clients.length > 0,
          label: t('planForClients'),
          errorMessage: step1Errors.clients
        }, {
          children: _jsx(MultiAutocomplete, {
            "data-testid": "clientSelect",
            error: !!step1Errors.clients,
            options: clientOptions,
            value: selectedClientIds,
            onChange: function (val) {
              return setSelectedClientIds(val);
            },
            ListboxProps: {
              style: {
                maxHeight: 200
              }
            },
            placeholder: t('pleaseSelect')
          })
        }))
      }))]
    }));
  };
  // Render LOB rows for a list of lob keys (Edit/View only — LOBs no longer support Hide)
  var renderLobRows = function (lobKeys, lobIndent) {
    return lobKeys.map(function (lobKey) {
      var _a;
      var parts = lobKey.split('_');
      var clientId = Number.parseInt(parts[0]);
      var lobId = Number.parseInt(parts[1]);
      var lob = allLobs.find(function (l) {
        return l.id === lobId;
      });
      if (!lob) return null;
      var lobPerm = (_a = lobPermissions[lobKey]) !== null && _a !== void 0 ? _a : defaultPerm;
      return _jsx(HierarchyPermRow, {
        label: lob.lobName,
        indent: lobIndent,
        permission: lobPerm,
        onChange: function (perm) {
          return handleCascadeLobPerm(clientId, lobId, perm);
        },
        userType: userType
      }, lobKey);
    });
  };
  // Render org hierarchy permissions in Step 2
  var renderOrgHierarchy = function () {
    if (isBpo) {
      return selectedClientIds.map(function (clientId) {
        var _a;
        var client = clients.find(function (c) {
          return c.id === clientId;
        });
        if (!client) return null;
        var clientPerm = (_a = clientPermissions[clientId]) !== null && _a !== void 0 ? _a : defaultPerm;
        var clientLobKeys = Array.from(selectedLobKeys).filter(function (k) {
          return k.startsWith("".concat(clientId, "_"));
        });
        var lobPermsForClient = clientLobKeys.map(function (k) {
          var _a;
          return (_a = lobPermissions[k]) !== null && _a !== void 0 ? _a : defaultPerm;
        });
        var clientChildrenMixed = lobPermsForClient.length > 0 && !lobPermsForClient.every(function (p) {
          return p === lobPermsForClient[0];
        });
        return _jsxs(Box, {
          children: [_jsx(HierarchyPermRow, {
            label: client.clientName,
            permission: clientPerm,
            onChange: function (perm) {
              return handleCascadeClientPerm(clientId, perm);
            },
            disabled: clientChildrenMixed,
            userType: userType,
            hideOption: true
          }), clientPerm !== StatusPermission.Hide && renderLobRows(clientLobKeys, 1)]
        }, clientId);
      });
    }
    // Non-BPO: LOB -> Sub-LOB hierarchy
    return renderLobRows(Array.from(selectedLobKeys), 0);
  };
  // Render Step 2: Permissions
  var renderStep2 = function () {
    return _jsxs(Grid, __assign({
      container: true,
      spacing: 4
    }, {
      children: [_jsx(Grid, __assign({
        item: true,
        xs: 12
      }, {
        children: _jsx(InputLabel, __assign({
          required: true
        }, {
          children: t('featurePermissions')
        }))
      })), _jsx(PermissionSection, {
        label: t('capacityPlanning'),
        name: "capacityPermission",
        control: control,
        userType: userType
      }), _jsx(PermissionSection, {
        label: t('financials'),
        name: "financialPermission",
        control: control,
        hidePermission: true,
        disabled: !(company === null || company === void 0 ? void 0 : company.financialLicense),
        userType: userType
      }), _jsx(PermissionSection, {
        label: t('recruitmentAndTrainingPlanner'),
        name: "recruitmentPermission",
        control: control,
        hidePermission: true,
        disabled: !(company === null || company === void 0 ? void 0 : company.recruitmentLicense),
        userType: userType
      }), _jsx(PermissionSection, {
        label: t('actual'),
        name: "actualPermission",
        control: control,
        hidePermission: true,
        disabled: !(company === null || company === void 0 ? void 0 : company.actualLicense),
        userType: userType
      }), _jsx(PermissionGrid, __assign({
        item: true,
        xs: 12
      }, {
        children: _jsx(Divider, {})
      })), _jsxs(PermissionGrid, __assign({
        item: true,
        xs: 12,
        display: "flex"
      }, {
        children: [_jsx(Grid, __assign({
          item: true,
          xs: 6
        }, {
          children: _jsx(Typography, __assign({
            paddingTop: 2
          }, {
            children: t('orgConfig')
          }))
        })), _jsx(Grid, __assign({
          item: true,
          xs: 6,
          pl: 2
        }, {
          children: _jsxs(RadioGroup, __assign({
            row: true,
            value: orgConfigPermission,
            onChange: function (_, val) {
              return setOrgConfigPermission(val);
            }
          }, {
            children: [_jsx(FormControlLabel, {
              control: _jsx(Radio, {}),
              label: t('edit'),
              value: StatusPermission.Edit,
              disabled: !isAdminLicense
            }), _jsx(FormControlLabel, {
              control: _jsx(Radio, {}),
              label: t('view'),
              value: StatusPermission.View
            }), _jsx(FormControlLabel, {
              control: _jsx(Radio, {}),
              label: t('hide'),
              value: StatusPermission.Hide,
              disabled: isAdminLicense
            })]
          }))
        }))]
      })), (selectedLobKeys.size > 0 || selectedClientIds.length > 0) && _jsxs(_Fragment, {
        children: [_jsx(Grid, __assign({
          item: true,
          xs: 12
        }, {
          children: _jsx(Divider, {})
        })), _jsxs(Grid, __assign({
          item: true,
          xs: 12
        }, {
          children: [_jsx(InputLabel, __assign({
            required: true,
            sx: {
              mb: 1
            }
          }, {
            children: t('orgPermissions')
          })), _jsx(OrgPermCard, {
            children: renderOrgHierarchy()
          })]
        }))]
      })]
    }));
  };
  return _jsx(StyledDialog, __assign({
    open: open,
    onClose: onClose
  }, {
    children: _jsxs(Box, __assign({
      component: "form",
      onSubmit: handleSubmit(handleFormSubmit)
    }, {
      children: [_jsx(DialogTitle, __assign({
        variant: "h2"
      }, {
        children: t(userId ? 'editUserTittle' : 'addNewUserTittle')
      })), _jsx(DialogContent, {
        children: _jsxs(FallbackComponent, __assign({
          requesting: isLoading,
          overlay: true
        }, {
          children: [_jsx(ErrorMessageBox, {
            errors: [userData.error, accessData.error, createData.error, updateData.error, saveAccessData.error]
          }), activeStep === 0 ? renderStep1() : renderStep2()]
        }))
      }), _jsxs(DialogActions, __assign({
        sx: {
          gap: 2
        }
      }, {
        children: [_jsx(Button, __assign({
          variant: "outlined",
          onClick: onClose
        }, {
          children: t('translation:action.cancel')
        })), _jsxs(Box, {
          children: [activeStep === 1 && _jsx(Button, __assign({
            variant: "outlined",
            onClick: function () {
              return setActiveStep(0);
            },
            sx: {
              mr: 1
            }
          }, {
            children: t('translation:action.previous') || 'Previous'
          })), activeStep === 0 ? _jsx(Button, __assign({
            variant: "contained",
            onClick: handleNext
          }, {
            children: t('translation:action.next') || 'Next'
          })) : _jsx(LoadingButton, __assign({
            loading: isSaving,
            variant: "contained",
            type: "submit",
            disabled: allPermsHidden
          }, {
            children: t('translation:action.save')
          }))]
        })]
      }))]
    }))
  }));
};